<template>
  <div>
    <v-col cols="12">
      <div class="group-form">
        <v-row>
          <v-col cols="12 py-0 pt-2 px-8">
            <h3>Chi tiết</h3>
          </v-col>
          <v-col cols="3" class="px-8 py-0 pt-2">
            <p class="text-bold mb-1">Số lượt tối đa/user</p>
            <validation-provider
              v-slot="{ errors }"
              class="mb-2"
              :rules="{ max: 10, min_value: 0, alpha_num: true }"
              name="Số lượt tối đa/user"
            >
              <v-text-field
                class="text-field text-field-number"
                :error-messages="errors"
                :clearable="true"
                placeholder="Nhập số lượng"
                outlined
                dense
                type="number"
                :disabled="isDisableActive"
                v-model="campaign.numberOfAvailableUser"
              ></v-text-field>
            </validation-provider>
          </v-col>
        </v-row>
      </div>
    </v-col>
    <v-col cols="12">
      <div class="group-form">
        <v-row>
          <v-col cols="12 py-0 pt-2 px-8">
            <h3>Điều kiện áp dụng</h3>
          </v-col>
          <v-col cols="3" class="px-8 py-0 pt-2">
            <p class="text-bold mb-1">Giá trị đơn hàng tối thiểu*</p>
            <validation-provider
              v-slot="{ errors }"
              class="mb-2"
              :rules="{ required: true, max: 10, min_value: 0, alpha_num: true }"
              name="Giá trị đơn hàng tối thiểu"
            >
              <v-text-field
                class="text-field text-field-number"
                :error-messages="errors"
                :clearable="true"
                placeholder="Nhập giá trị đơn hàng tối thiểu"
                outlined
                dense
                type="number"
                :disabled="isDisableActive"
                v-model="campaign.minimumAmount"
              ></v-text-field>
            </validation-provider>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3" class="px-8 py-0">
            <p class="text-bold mb-1">Hình thức sản phẩm*</p>
            <validation-provider
              v-slot="{ errors }"
              class="mb-2"
              :rules="{ required: true }"
              name="Hình thức sản phẩm"
            >
              <v-select
                class="text-field"
                :error-messages="errors"
                :items="typeOfProducts"
                item-value="id"
                item-text="name"
                :aLight="'right'"
                placeholder="Chọn hình thức sản phẩm"
                attach
                outlined
                dense
                v-model="campaign.typeOfProduct"
                :disabled="isDisableActive"
                :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
              ></v-select>
            </validation-provider>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12 py-0 pt-2 px-8">
            <h3>Mua sản phẩm tặng sản phẩm (Buy x get y)</h3> 
          </v-col>
          <v-col cols="12" class="px-8 py-0 pt-2">
            <validation-observer ref="validatorNewItem">
              <v-simple-table class="table-layout table-custom table-sku">
                <thead>
                  <tr>
                    <th class="col-sku-code">SKU mua</th>
                    <th class="col-sku-name">Sản phẩm mua</th>
                    <th class="col-quantity text-center">Số lượng mua</th>
                    <th class="col-sku-code-bonus">SKU tặng</th> 
                    <th class="col-sku-name">Sản phẩm tặng</th> 
                    <th class="col-quantity-bonus text-center">Số lượng tặng</th> 
                    <th class="col-action text-center">Thao tác</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <validation-provider
                        v-slot="{ errors }"
                        class=""
                        :rules="{ required: true }"
                        name="SKU mua"
                      >
                        <v-text-field
                          class="text-field"
                          :error-messages="errors"
                          :clearable="true"
                          placeholder="Nhập SKU"
                          outlined
                          dense
                          maxLength="50"
                          v-model="purchasedProductCode"
                          :disabled="isDisableActive"
                          @keyup="checkSku(purchasedProductCode)"
                        ></v-text-field>
                      </validation-provider>
                    </td>
                    <td>
                      <validation-provider
                        v-slot="{ errors }"
                        class=""
                        :rules="{ required: true }"
                        name="Tên SKU"
                      >
                        <v-autocomplete
                          class="text-field"
                          :error-messages="errors"
                          :clearable="true"
                          :items="allSkus"
                          item-value="code"
                          item-text="name"
                          :aLight="'right'"
                          placeholder="Nhập tên SKU"
                          attach
                          outlined
                          dense
                          v-model="purchasedProductCode"
                          :disabled="isDisableActive"
                          :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                        ></v-autocomplete>
                      </validation-provider>
                    </td>
                    <td>
                      <validation-provider
                        v-slot="{ errors }"
                        class=""
                        :rules="{ required: true, max: 10, min_value: 0, alpha_num: true }"
                        name="Số lượng mua"
                      >
                        <v-text-field
                          class="text-field text-field-number"
                          :error-messages="errors"
                          :clearable="true"
                          placeholder="Nhập số lượng"
                          outlined
                          dense
                          maxLength="100"
                          type="number"
                          :disabled="isDisableActive"
                          v-model="purchasedProductQuantity"
                        ></v-text-field>
                      </validation-provider>
                    </td>
                    <td>
                      <div class="d-flex" v-for="(itemCode, indexCode) in giftProducts" :key="indexCode">
                        <div class="sku-code">
                          <validation-provider
                            v-slot="{ errors }"
                            class=""
                            :rules="{ required: true}"
                            :name="`SKU tặng ${indexCode + 1}`"
                          >
                            <v-text-field
                              class="text-field"
                              :error-messages="errors"
                              :clearable="true"
                              placeholder="Nhập SKU"
                              outlined
                              dense
                              maxLength="50"
                              v-model="itemCode.productCode"
                              :disabled="isDisableActive"
                              @keyup="checkSkuGiftProducts(itemCode)"
                            ></v-text-field>
                          </validation-provider>
                        </div>
                        <div class="pt-3 pl-1">
                          <v-tooltip bottom v-if="indexCode === 0">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon color="#329D20" v-bind="attrs" v-on="on" @click="addProductCode()" :disabled="isDisableActive">
                                mdi-plus-box
                              </v-icon>
                            </template>
                            <span>Thêm</span>
                          </v-tooltip>
                          <v-tooltip bottom v-if="indexCode != 0 || giftProducts.length > 1">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon color="#959595" v-bind="attrs" v-on="on" @click="removeProductCode(itemCode, indexCode)" :disabled="isDisableActive">
                                mdi-delete
                              </v-icon>
                            </template>
                            <span>Xóa</span>
                          </v-tooltip>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div v-for="(itemCode, indexCode) in giftProducts" :key="indexCode">
                        <validation-provider
                          v-slot="{ errors }"
                          class=""
                          :rules="{ required: true}"
                          :name="`Tên SKU ${indexCode + 1}`"
                        >
                          <v-autocomplete
                            class="text-field"
                            :error-messages="errors"
                            :clearable="true"
                            :items="allSkus"
                            item-value="code"
                            item-text="name"
                            :aLight="'right'"
                            placeholder="Nhập tên SKU"
                            attach
                            outlined
                            dense
                            :disabled="isDisableActive"
                            v-model="itemCode.productCode"
                            @change="changeSkuGiftProducts(itemCode)"
                            :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                          ></v-autocomplete>
                        </validation-provider>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex" v-for="(itemCode, indexCode) in giftProducts" :key="indexCode">
                        <validation-provider
                          v-slot="{ errors }"
                          :rules="{ required: true, max: 10, min_value: 0, alpha_num: true }"
                          :name="`Số lượng tặng ${indexCode + 1}`"
                        >
                          <v-text-field
                            class="text-field text-field-number"
                            :error-messages="errors"
                            :clearable="true"
                            placeholder="Nhập số lượng"
                            outlined
                            dense
                            type="number"
                            :disabled="isDisableActive"
                            v-model="itemCode.quantity"
                          ></v-text-field>
                        </validation-provider>
                      </div>
                    </td>
                    <td class="text-center">
                      <v-tooltip bottom class="mr-2">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon color="#329D20" v-bind="attrs" v-on="on" @click="addRow" :disabled="isDisableActive">
                            mdi-plus-box
                          </v-icon>
                        </template>
                        <span>Thêm</span> 
                      </v-tooltip>
                    </td>
                  </tr>
                  
                  <tr v-for="(item, index) in giftProductsByBoughtProducts" :key="index">
                    <td>
                      {{ item.purchasedProductCode }}
                    </td>
                    <td>
                      {{ allSkuObj[item.purchasedProductCode] }}
                    </td>
                    <td class="text-center">
                      {{ item.purchasedProductQuantity }}
                    </td>
                    <td>
                      <div class="d-flex" v-for="(itemCode, indexCode) in item.giftProducts" :key="`code-${index}-${indexCode}`">
                        <div class="sku-code">
                          <v-text-field
                            class="text-field text-field-no-message"
                            :clearable="true"
                            placeholder="Nhập SKU"
                            outlined
                            dense
                            maxLength="50"
                            :disabled="isDisableActive"
                            v-model="itemCode.productCode"
                            @keyup="checkSkuGiftProducts(itemCode)"
                          ></v-text-field>
                        </div>
                        <div class="pt-3 pl-1">
                          <v-tooltip bottom v-if="indexCode === 0">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon class="" color="#329D20" v-bind="attrs" v-on="on" @click="addProductCode(item)" :disabled="isDisableActive">
                                mdi-plus-box
                              </v-icon>
                            </template>
                            <span>Thêm</span>
                          </v-tooltip>
                          <v-tooltip bottom v-if="indexCode != 0 || item.giftProducts.length > 1">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon class="" color="#959595" v-bind="attrs" v-on="on" @click="removeProductCode(itemCode, indexCode, item)" :disabled="isDisableActive">
                                mdi-delete
                              </v-icon>
                            </template>
                            <span>Xóa</span>
                          </v-tooltip>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex" v-for="(itemCode, indexCode) in item.giftProducts" :key="`name-${index}-${indexCode}`">
                        <v-autocomplete
                          class="text-field text-field-no-message"
                          :clearable="true"
                          :items="allSkus"
                          item-value="code"
                          item-text="name"
                          :aLight="'right'"
                          placeholder="Nhập tên SKU"
                          attach
                          outlined
                          dense
                          v-model="itemCode.productCode"
                          :disabled="isDisableActive"
                          @change="changeSkuGiftProducts(itemCode)"
                          :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                        ></v-autocomplete>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex" v-for="(itemCode, indexCode) in item.giftProducts" :key="`quantity-${index}-${indexCode}`">
                        <v-text-field
                          class="text-field text-field-no-message text-field-number"
                          :clearable="true"
                          placeholder="Nhập số lượng"
                          outlined
                          dense
                          maxLength="10"
                          type="number"
                          v-model="itemCode.quantity"
                          :disabled="isDisableActive"
                        ></v-text-field>
                      </div>
                    </td>
                    <td class="text-center">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon color="#959595" v-bind="attrs" v-on="on" @click="removeRow(item, index)" :disabled="isDisableActive">
                            mdi-delete
                          </v-icon>
                        </template>
                        <span>Xóa</span>
                      </v-tooltip>
                    </td>
                  </tr>
                  <tr style="height: 200px;"></tr>
                </tbody>
              </v-simple-table>
            </validation-observer>
          </v-col>
        </v-row>
      </div> 
    </v-col>
  </div>
</template>

<script>
import RepositoryFactory from '@/repositories/RepositoryFactory';
const ProductRepository = RepositoryFactory.get('product');

export default {
  props: {
    campaign: {
      type: Object,
      default: () => {},
    },
    readonly: { type: Boolean, default: false },
    giftProductsByBoughtProducts: {
      type: Array,
      default: () => [],
    },
    isDisablePending: {
      type: Boolean,
      default: () => false,
    },
    typeOfProducts: {
      type: Array,
      default: () => [],
    },
    isDisableActive: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
  },
  data() {
    return {
      allSkus: [],
      purchasedProductCode: null,
      purchasedProductQuantity: null,
      productCode: null,
      quantity: null,
      giftProducts: [
        {
          productCode: null,
          quantity: null
        },
      ],
      allSkuObj: {},
    };
  },
  computed: {
  },
  async created() {
    this.getAllSkus();
  },
  beforeDestroy() {
  },
  methods: {
    onChangeApplyForm() {},
    async addRow() {
      const isValid = await this.$refs.validatorNewItem.validate();
      if (!isValid) {
        // ABORT!!
        return;
      }
      const purchasedProductCodeSearch = this.allSkus.find((item) => item.code === this.purchasedProductCode);
      if (!purchasedProductCodeSearch && this.purchasedProductCode) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: 'Không tìm thấy sản phẩm mua',
        });
      }
      const exist = (this.giftProductsByBoughtProducts || [])
        .find(it => it.purchasedProductCode == this.purchasedProductCode);
      if (exist) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: 'Điều kiện SKU mua này đã tồn tại',
        });
      }
      const codeEmpty = this.giftProducts.find((item) => !item.productCode || (item.productCode && !item.productCode.trim()));
      if (codeEmpty) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: 'Chưa nhập đủ sản phẩm tặng',
        });
      }

      const giftProducts = this.giftProducts.map((item) => {
        const productCodeSearch = this.allSkus.find((item2) => item2.code === item.productCode);
        return {
          productCode: productCodeSearch.code,
          productName: productCodeSearch.name,
          quantity: item.quantity,
          skuType: productCodeSearch.itemType,
        }
      });
      this.giftProductsByBoughtProducts.push({
        purchasedProductCode: this.purchasedProductCode,
        purchasedProductName: purchasedProductCodeSearch.name,
        purchasedProductSkuType: purchasedProductCodeSearch.itemType,
        purchasedProductQuantity: this.purchasedProductQuantity,
        giftProducts,
      });
      this.purchasedProductCode = null;
      this.purchasedProductQuantity = null;
      this.giftProducts = [
        {
          productCode: null,
          quantity: null
        }
      ];
      this.$refs.validatorNewItem.reset();
    },
    removeRow(item, index) {
      this.giftProductsByBoughtProducts.splice(index, 1);
    },
    async getAllSkus() {
      const params = {
        sku_name: '',
        status: 'active',
        sku_types: ['duo', 'tutor', 'combo'],
      }
      const res = await ProductRepository.basicSearchForCombo(params);
      this.allSkus = res.data;
      this.allSkus.forEach((item) => this.allSkuObj[item.code] = item.name);
    },
    checkCode: _.debounce(function () {
      const sku = this.allSkus.find((item) => item.code === this.newSkuCode);
      if (this.newSkuCode && !sku) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: 'SKU không tồn tại hoặc đã ngừng hoạt động',
        });
      }
    }, 500),
    addProductCode(item = null) {
      if (item) {
        return item.giftProducts.push(
          {
            productCode: null,
            quantity: null,
          }
        );
      }
      this.giftProducts.push(
        {
          productCode: null,
          quantity: null,
        }
      );
    },
    removeProductCode(item, index, itemGroup = null) {
      if (itemGroup) {
        return itemGroup.giftProducts.splice(index, 1);
      }

      this.giftProducts.splice(index, 1);
    },
    checkSku: _.debounce(function (inputVal) {
      const sku = this.allSkus.find((item) => item.code === inputVal);
      if (!sku && inputVal) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: 'Không tìm thấy SKU',
        });
      }
    }, 500),
    checkSkuGiftProducts: _.debounce(function (itemGift) {
      const sku = this.allSkus.find((item) => item.code === itemGift.productCode);
      if (!sku && itemGift.productCode) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: 'Không tìm thấy SKU',
        });
      }
      if (sku) {
        itemGift.skuType = sku.itemType;
      }
    }, 500),
    changeSkuGiftProducts(itemGift) {
      const sku = this.allSkus.find((item) => item.code === itemGift.productCode);
      itemGift.skuType = sku.itemType;
    },
  },
  watch: {
  }
};
</script>
<style scoped lang="scss">
.col-sku-code {
  width: 10%;
}
.col-sku-code-bonus {
  width: 14%;
}
.col-sku-name {
  width: 23%;
}
.col-quantity {
  width: 12%;
}
.col-quantity-bonus {
  width: 10%;
}
.col-action {
  width: 10%;
}
.text-bold {
  font-weight: bold;
}
.gr-action {
  position: relative;
  top: 0px;
  z-index: 10;

  .btn-search {
    background: #fff !important;
    min-width: 50px;
    color: #666666 !important;
  }

  .btn-create-product {
    background: #6587FF !important;
    color: #fff !important;
  }
}
.menu__custom {
  top: calc(20% - 75px) !important;
  left: 96% !important;
  transform: translateX(-96%) !important;
}
.btn-search {
  background: #6587FF !important;
}

.box-product-type {
  width: 300px;
}

.table-custom {
  th {
    background: #E7E8FF;
    border-left: 1px solid #fff;
  }
}

.card-item-custom {
  width: 100%;
  height: 40px;
  background: #fff;
  border-bottom: 1px solid #ccc;
  line-height: 40px;
}
.sku-code {
  max-width: 70%;
}
</style>

<style lang="scss">
.v-select-mini {
  .v-input__slot {
    min-height: 28px !important;
    height: 28px;
  }

  .v-text-field__details {
    display: none;
  }

  .v-input__append-inner {
    margin-top: 3px !important;
  }
}

.v-tab--active {
  color: #5E64FF !important;
}
.v-tabs-slider-wrapper {
  .v-tabs-slider {
    background-color: #5E64FF !important;
  }
}
.cursor-pointer {
  cursor: pointer;
}
</style>
